import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {LovValueSummary} from '../model/lovValueSummary.model';
import {Injectable} from '@angular/core';
import {LovListSummaryConverter} from '../../../lov-list/api/model/converter/lovListSummary.converter';
import {LovValueOrCustomValueModel} from '../model/LovValueOrCustomValue.model';
import {LovValueSummaryConverter} from './LovValueSummary.converter';

@Injectable({providedIn: 'root'})
export class LovValueOrCustomValueConverter extends HttpModelConverter<LovValueOrCustomValueModel>{

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): LovValueOrCustomValueModel {
        return new LovValueOrCustomValueModel();
    }

    protected enrichObject(result: LovValueOrCustomValueModel, src: LovValueOrCustomValueModel) {
        result.lovValue = this.lovValueSummaryConverter.convert(src.lovValue);
    }
}
